<button
  (click)="onclick.emit()"
  [disabled]="disabled"
  [type]="buttonType"
  class="digital-platform-button {{ disabled ? 'disabled' : '' }} {{ size }} {{
    color
  }} {{ backgroundType }} {{ className }}"
  [style]="style"
>
  {{ label }}
</button>
